function normalizeStoreSearchValue(value) {
  return value.normalize('NFKC').toLocaleLowerCase('ja').replace(/\s+/g, '');
}

function initializeYamadaStores(root) {
  if (root.dataset.yamadaStoresInitialized === 'true') return;

  const input = root.querySelector('[data-yamada-search]');
  const stores = [...root.querySelectorAll('[data-yamada-store]')];
  const regions = [...root.querySelectorAll('[data-yamada-region]')];
  const resultCount = root.querySelector('[data-yamada-result-count]');
  const noResults = root.querySelector('[data-yamada-no-results]');

  if (!input || !resultCount) return;

  root.dataset.yamadaStoresInitialized = 'true';

  for (const store of stores) {
    store.dataset.normalizedSearch = normalizeStoreSearchValue(store.dataset.search || store.textContent || '');
  }

  const updateResults = () => {
    const query = normalizeStoreSearchValue(input.value.trim());
    let totalVisible = 0;

    for (const region of regions) {
      const regionStores = [...region.querySelectorAll('[data-yamada-store]')];
      let regionVisible = 0;

      for (const store of regionStores) {
        const matches = !query || store.dataset.normalizedSearch.includes(query);
        store.hidden = !matches;
        if (matches) regionVisible += 1;
      }

      region.hidden = regionVisible === 0;
      const count = region.querySelector('[data-yamada-region-count]');
      if (count) count.textContent = String(regionVisible);

      if (query && regionVisible > 0) {
        region.open = true;
      } else if (!query) {
        region.open = region.hasAttribute('data-default-open');
      }

      totalVisible += regionVisible;
    }

    resultCount.textContent = query ? `${totalVisible}店舗が見つかりました` : `掲載 ${stores.length}店舗`;
    if (noResults) noResults.hidden = totalVisible !== 0;
  };

  input.addEventListener('input', updateResults);
  input.addEventListener('search', updateResults);
  updateResults();
}

function initializeAllYamadaStores(scope = document) {
  for (const root of scope.querySelectorAll('[data-yamada-stores]')) {
    initializeYamadaStores(root);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeAllYamadaStores(), { once: true });
} else {
  initializeAllYamadaStores();
}

document.addEventListener('shopify:section:load', (event) => initializeAllYamadaStores(event.target));
